module.exports = __webpack_public_path__ + "img/btn_exit.685d83fc.png";